import { inject, Injectable } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

export interface IframeMessage {
  action: string;
  data?: any;
}

@Injectable({ providedIn: 'root' })
export class IFrameService {
    private sanitizer = inject(DomSanitizer);
    private readonly slob: string = environment.iframe_slob;
    constructor() { }


    /**
 * Obtiene la URL del iframe marcada como segura
 */
    getIframeUrl(): SafeResourceUrl {
        console.log('Comunicación Establecida con iframe');
        const token = sessionStorage.getItem('AuthToken') || '';
        const iframeUrl = `${environment.iframe_receptor
            }?parentUrl=${encodeURIComponent(
                environment.iframe_emisor
            )}&token=${encodeURIComponent(token)}&slob=${this.slob}`;
        return this.sanitizer.bypassSecurityTrustResourceUrl(iframeUrl);
    }

    /**
     * Configura la comunicación con el iframe
     * @param onCloseCallback Función a ejecutar cuando el iframe envía señal de cerrar
     */
    setupIframeCommunication(onCloseCallback: () => void): void {
        const receptorOrigin = new URL(environment.iframe_receptor).origin;

        window.addEventListener('message', (event) => {
            if (event.origin !== receptorOrigin) return;

            if (event.data.action === 'closeIframe') {
                onCloseCallback();
                console.log('Recibiendo Cierre:', event.data);
            }

            if (event.data.action === 'QuotesRecieve') {
                onCloseCallback();
                console.log('Recibiendo Cotización:', event.data);
            }
        });
    }

    /**
     * Envía mensaje al iframe
     * @param action Acción a enviar
     * @param data Datos opcionales
     */
    sendMessageToIframe(action: string, data?: any): void {
        const iframe = document.getElementById('iframe-payment-link-generator') as HTMLIFrameElement;
        if (iframe?.contentWindow) {
            const receptorOrigin = new URL(environment.iframe_receptor).origin;
            iframe.contentWindow.postMessage({ action, data }, receptorOrigin);
        }
    }

    /**
     * Previene el scroll del body cuando el iframe está activo
     */
    preventBodyScroll(): void {
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
        document.body.style.height = '100%';
    }

    /**
     * Restaura el scroll del body
     */
    restoreBodyScroll(): void {
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';
        document.body.style.height = '';
    }

}